<div class="main-container">
  @if (!loggedIn) {
  <header class="hero-section">
    <div class="hero-inner">
      <div class="hero-copy">
        <h1>{{ 'main.heroTitle' | t }}</h1>
        <p class="subtitle">{{ 'main.heroSubtitle' | t }}</p>
        <ul class="hero-points">
          <li>{{ 'main.promoPoint1' | t }}</li>
          <li>{{ 'main.promoPoint2' | t }}</li>
          <li>{{ 'main.promoPoint3' | t }}</li>
        </ul>
        <div class="hero-cta">
          <button type="button" class="cta-signup" (click)="onSignup()">
            {{ 'main.promoSignup' | t }}
          </button>
          <a routerLink="/signin" class="cta-signin">{{ 'main.promoSignin' | t }}</a>
        </div>
      </div>
      <app-promo-carousel class="hero-carousel"></app-promo-carousel>
    </div>
  </header>
  }

  @if (loggedIn) {
  <section class="trees-section my-trees">
    <h2>{{ 'main.myTreesTitle' | t }}</h2>

    @if (loadingMy) {
      <div class="loading-spinner">
        <div class="spinner"></div>
        <p>{{ 'main.loadingTrees' | t }}</p>
      </div>
    }

    @if (!loadingMy && myTrees.length > 0) {
      <div class="trees-grid">
        @for (tree of myTrees; track tree.id) {
          <div class="tree-card" (click)="openTree(tree)">
            <div class="card-icon">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M12 2v6m0 0a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm-4 9v5m8-5v5m-8 0a3 3 0 1 0-6 0m20 0a3 3 0 1 1-6 0"/>
              </svg>
            </div>
            <h3 class="tree-title">{{ tree.title }}</h3>
            <div class="tree-stats">
              <div class="stat-item">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                  <circle cx="9" cy="7" r="4"/>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87m-4-12a4 4 0 0 1 0 7.75"/>
                </svg>
                @if (tree.person_count) {
                  <span>{{ 'main.personCount' | t: { count: tree.person_count } }}</span>
                }
                @if (!tree.person_count) {
                  <span>{{ 'common.loading' | t }}</span>
                }
              </div>
            </div>
            <div class="card-footer">
              <span class="view-link">{{ 'main.viewTree' | t }}</span>
            </div>
          </div>
        }
        <!-- Kolejne drzewo zaklada sie tu, bez wchodzenia w ustawienia konta -->
        <button type="button" class="tree-card new-tree-card" (click)="createTree()">
          <div class="card-icon card-icon-plus">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M12 5v14M5 12h14"/>
            </svg>
          </div>
          <h3 class="tree-title">{{ 'main.newTreeCard' | t }}</h3>
          <p class="new-tree-text">{{ 'main.newTreeCardText' | t }}</p>
        </button>
      </div>
    }

    <!-- Swiezy uzytkownik: zamiast pustej listy - co zrobic dalej. Pierwszy
         krok to zalozenie drzewa (od razu tutaj), obok dwie drogi poboczne:
         import GEDCOM (po utworzeniu drzewa) i zaproszenie od rodziny. -->
    @if (!loadingMy && myTrees.length === 0) {
      <div class="onboarding">
        <div class="onboarding-main">
          <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M12 2v6m0 0a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm-4 9v5m8-5v5m-8 0a3 3 0 1 0-6 0m20 0a3 3 0 1 1-6 0"/>
          </svg>
          <h3>{{ 'main.myTreesEmpty' | t }}</h3>
          <p>{{ 'main.onboardingText' | t }}</p>
          <button type="button" class="cta-create" (click)="createTree()">
            {{ 'account.createTree' | t }}
          </button>
        </div>
        <div class="onboarding-steps">
          <div class="onboarding-step">
            <span class="step-number">1</span>
            <div>
              <h4>{{ 'main.onboardingStep1Title' | t }}</h4>
              <p>{{ 'main.onboardingStep1Text' | t }}</p>
            </div>
          </div>
          <div class="onboarding-step">
            <span class="step-number">2</span>
            <div>
              <h4>{{ 'main.onboardingStep2Title' | t }}</h4>
              <p>{{ 'main.onboardingStep2Text' | t }}</p>
            </div>
          </div>
          <div class="onboarding-step">
            <span class="step-number">3</span>
            <div>
              <h4>{{ 'main.onboardingStep3Title' | t }}</h4>
              <p>{{ 'main.onboardingStep3Text' | t }}</p>
            </div>
          </div>
          <p class="onboarding-invite">{{ 'main.onboardingInvite' | t }}</p>
        </div>
      </div>
    }
  </section>
  }

  <!-- Wyszukiwanie osob po wszystkich drzewach, ktore wolno pokazac
       odwiedzajacemu - dziala takze bez logowania -->
  <section class="search-section">
    <h2>{{ 'search.title' | t }}</h2>
    <p class="search-lead">{{ 'search.intro' | t }}</p>
    <form class="search-form" (ngSubmit)="onSearch()">
      <input type="search" name="q" [(ngModel)]="searchQuery" maxlength="120"
        [placeholder]="'search.placeholder' | t" [attr.aria-label]="'search.title' | t" />
      <button type="submit" [disabled]="!searchQuery.trim()">{{ 'common.search' | t }}</button>
    </form>
  </section>

  <section class="trees-section" [class.secondary]="loggedIn">
    <h2>{{ (loggedIn ? 'main.otherTreesTitle' : 'main.treesTitle') | t }}</h2>

    @if (loading) {
      <div class="loading-spinner">
        <div class="spinner"></div>
        <p>{{ 'main.loadingTrees' | t }}</p>
      </div>
    }

    @if (!loading && publicTrees.length > 0) {
      <div class="trees-grid">
        @for (tree of publicTrees; track tree) {
          <div class="tree-card" (click)="openTree(tree)">
            <div class="card-icon">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M12 2v6m0 0a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm-4 9v5m8-5v5m-8 0a3 3 0 1 0-6 0m20 0a3 3 0 1 1-6 0"/>
              </svg>
            </div>
            <h3 class="tree-title">{{ tree.title }}</h3>
            <div class="tree-stats">
              <div class="stat-item">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                  <circle cx="9" cy="7" r="4"/>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87m-4-12a4 4 0 0 1 0 7.75"/>
                </svg>
                @if (tree.person_count) {
                  <span>{{ 'main.personCount' | t: { count: tree.person_count } }}</span>
                }
                @if (!tree.person_count) {
                  <span>{{ 'common.loading' | t }}</span>
                }
              </div>
            </div>
            <div class="card-footer">
              <span class="view-link">{{ 'main.viewTree' | t }}</span>
            </div>
          </div>
        }
      </div>
    }

    @if (!loading && publicTrees.length === 0) {
      <div class="empty-state">
        <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M12 2v6m0 0a3 3 0 1 0 0 6 3 3 0 0 0 0-6z"/>
        </svg>
        <h3>{{ 'main.emptyTitle' | t }}</h3>
        <p>{{ 'main.emptyText' | t }}</p>
      </div>
    }
  </section>

  <!-- Zalogowany normalnie nie widzi oferty (ma tu swoje drzewa), ale wejscie
       przez /pricing to jawna prosba o cennik - wtedy pokazujemy go zawsze -->
  @if (!loggedIn || pricingRoute) {
  <div id="pricing">
    <app-pricing (loaded)="onPricingLoaded()"></app-pricing>
  </div>
  }

  @if (!loggedIn) {
  <footer class="info-section">
    <div class="info-card">
      <h3>{{ 'main.infoOwnTitle' | t }}</h3>
      <p>{{ 'main.infoOwnText' | t }}</p>
    </div>
    <div class="info-card">
      <h3>{{ 'main.infoShareTitle' | t }}</h3>
      <p>{{ 'main.infoShareText' | t }}</p>
    </div>
    <div class="info-card">
      <h3>{{ 'main.infoKeepTitle' | t }}</h3>
      <p>{{ 'main.infoKeepText' | t }}</p>
    </div>
  </footer>
  }

  <!-- Kontakt do obslugi kupujacego stoi TU, a nie tylko w regulaminie:
       weryfikacja Paddle wymaga, zeby dalo sie go znalezc ze strony glownej,
       bez wchodzenia w dokumenty. Pusty numer telefonu chowa sie sam. -->
  <nav class="legal-links">
    <a routerLink="/privacy">{{ 'main.privacy' | t }}</a>
    <a routerLink="/terms">{{ 'main.terms' | t }}</a>
    <a routerLink="/refunds">{{ 'main.refunds' | t }}</a>
    <a routerLink="/data-deletion">{{ 'main.dataDeletion' | t }}</a>
    <a [href]="'mailto:' + legal.contactEmail">{{ 'main.contact' | t }}: {{ legal.contactEmail }}</a>
    @if (legal.companyPhone) {
      <a [href]="phoneHref">{{ legal.companyPhone }}</a>
    }
  </nav>
</div>
